angular.module('cfn').directive('cfnGridNew', [
  '$rootScope',
  '$log',
  '$timeout',
  '$filter',
  'i18nFilter',
  '$compile',
  '$dialog',
  'propertySupport',
  'cfnGridEvents',
  'cfnGridFnHacks',
  'cfnGridSelection',
  'cfnGridView',
  'cfnGridRenderer',
  'cfnGridSizing',
  'cfnGridPrinting',
  'cfnGridModel',
  'cfnGridFiltering',
  'cfnGridSorting',
  'cfnGridTemplates',
  'cfnGridDefaults',
  function(
    $rootScope,
    $log,
    $timeout,
    $filter,
    i18nFilter,
    $compile,
    $dialog,
    propertySupport,
    cfnGridEvents,
    cfnGridFnHacks,
    cfnGridSelection,
    cfnGridView,
    cfnGridRenderer,
    cfnGridSizing,
    cfnGridPrinting,
    cfnGridModel,
    cfnGridFiltering,
    cfnGridSorting,
    cfnGridTemplates,
    cfnGridDefaults
  ) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        ngModel: '=', // model to an array of items. IMPORTANT: each item requires a unique .id!
        watchList: '@', // bool if the grid should watch on grid list length changes instead of only model changes.

        name: '@', // optional property to set a unique id to a specific grid

        width: '@', // sets the width of the grid to a pixel value. This is not required if there is a div container that has width
        height: '@', // sets the height of the grid to a pixel value. This is not required if there is a div container that has height

        showSecondTitle: '@', // if to show a second header for each column

        fixedcols: '@', // Number. Fixes a set of cols. The number is the count of columns to fix - counted from the left.
        // Currently works only with fixed height

        fixedcolheight: '@', // Number. Sets the height of one row.
        // Currently works only width fixed height

        init: '&', // function that gets called when the grid is initalized completely parameters: grid Controller and scope

        headerclick: '&',
        rowclick: '&', // gets called if a row is clicked. this should be an expression to a function name (rowData,rowIndex)
        cellclick: '&', // gets called if a cell is clicked. this should be an expression to a function name (rowData,rowIndex)
        rowdblclick: '&', // gets called if a row is dbl clicked. this should be an expression to a function name (rowData,rowIndex)
        celldblclick: '&', // gets called if a cell is dbl clicked. this should be an expression to a function name (rowData,rowIndex)

        afterupdatemodel: '&', // optional expression to a function name that gets called after the model in the grid has been updated
        selectionchange: '&', // optional expression to a function name that gets called when the selection of the grid has changed parameter: hash of selected elements

        rowclass: '@', // class:expression,...   allows custom row classes to be defined in the form "class:expression,class:expression,class:expression" Additionally for backwards compatibility the rowClasses in cfnGridCompatibility can be used

        defaultsortcolumn: '@', // name of the default sort column, append ':DESC' to reverse the sort direction
        defaultsortdirection: '@', // has no effect whatsoever

        multiselection: '@', // bool if multiselection is allowed
        moveSelectedToTop: '@', // bool if multiselection is enabled will move selected items to top
        checkboxselectable: '@', // bool if checkboxes should be displayed before the row that enables multiselection.
        disableclickselection: '@', // bool that disables click selection - often used in combination with checkboxselectable

        cookieName: '@', // cookie name sets the name of the grid settings to be stored in the cookie. (note: in future this will no longer be a cookie but a user setting)

        afterViewChange: '&', // function that gets called after the view data has changed

        deleteable: '@', // bool if the grid should automatically add a function for deleting rows.
        onDelete: '&', // if deletable = true and the user wants to delete a row this function is called with the clicked row as a parameter

        emptycontentmessage: '@', // message that gets displayed when

        // very new features that might still change
        infoObject: '=?', // sets information of the grid to an angular object. currently: infoObject.selection - [] of elements selected
        printable: '@', // if set to true a little button will appear that enables printing. Note: Maybe this requires further files from gea merge

        // future features
        datasource: '&', // this is a future feature to handle backend pagination. This needs to be discussed. Please contant Max and Arne

        // possibly deprecated and unused / not tested functions
        hoverstart: '&',
        hoverend: '&',
        noMaxHeight: '=?'
      },

      controller: 'cfnGridController',
      link: function(scope, element, attrs) {
        app.startPerfTimer('cfnGridLink');

        var msgElement = null;
        if (scope.rowclass) {
          scope.rowclasses = scope.rowclass.split(',');
        }
        // data map to be linked by id with row data
        scope.$rootScope = $rootScope;
        scope.emptyDataString = scope.emptycontentmessage; // TODO: check if this is really needed

        if (!scope.emptyDataString) {
          scope.emptyDataString = i18nFilter('fe.common.emptyGrid');
        }

        scope.loadingDataMessage = i18nFilter(
          'fe.common.loadingGridDataMessage'
        );

        var settings = {
          columns: []
        };

        if (!angular.isDefined(scope.noMaxHeight)) {
          scope.noMaxHeight = false;
        }

        scope.settings = settings;

        scope.$cfnGridEvents = cfnGridEvents.initEvents(scope, element, attrs);

        scope.$cfnGridSelection = cfnGridSelection.init(scope, element, attrs);

        scope.$cfnGridView = cfnGridView.init(scope, element, attrs);

        scope.$cfnGridRenderer = cfnGridRenderer.init(scope, element, attrs);

        scope.$cfnGridSizing = cfnGridSizing.init(scope, element, attrs);

        scope.$cfnGridModel = cfnGridModel.init(scope, element, attrs);

        scope.$cfnGridFiltering = cfnGridFiltering.init(scope, element, attrs);

        scope.$cfnGridSorting = cfnGridSorting.init(scope, element, attrs);

        var that = this;
        ang.callAfter(
          function() {
            scope.$cfnGridFnHacks = cfnGridFnHacks.init(scope, element, attrs);

            app.startPerfTimer('cfnGrid Build Html');

            var htmlObject = scope.$cfnGridRenderer.buildFixedRowHtml();

            app.stopPerfTimer('cfnGrid Build Html');
            app.stopPerfTimer('cfnGrid Classes');
            app.startPerfTimer('cfnGrid Compile');

            var compiledTable = scope.$cfnGridRenderer.compileHtml(htmlObject);

            app.stopPerfTimer('cfnGrid Compile');
            app.startPerfTimer('cfnGrid Append');

            element.find('.tableContent').append(compiledTable.table);
            element.find('.cfnTableHeader').append(compiledTable.header);
            scope.$$printableContent = compiledTable.printableTable;

            app.stopPerfTimer('cfnGrid Append');
            app.startPerfTimer('cfnGrid Install watch');

            //var firstFilterChange = true;
            scope.$watch(
              'view.filters',
              function(newValue, oldValue) {
                if (newValue !== oldValue) scope.updateViewRequest();
                //}
                // firstFilterChange = false;
              },
              true
            );
            app.stopPerfTimer('cfnGrid Install watch');
          },
          undefined,
          'cfnGid Build'
        );

        ang.callAfter(function() {
          scope.$cfnGridSorting.onGridInit();

          scope.$cfnGridModel.addWatchers();
        }, scope);

        // automatic resize
        if (scope.width == undefined && scope.height == undefined) {
          // important to do not watch on jquery expressions..
          var resize = function() {
            ang.apply(scope, function() {
              scope.width = element.parent().width();
              scope.height = element.parent().height();
            });
          };

          resize();
          scope.window = $rootScope.window;
          scope.$watchCollection(
            '[window.width, window.height, window.displayRight, window.sizeChanged]',
            function() {
              ang.callAfter(function() {
                resize();
              });
            }
          );
        }

        scope.$scfnGridPrinting = cfnGridPrinting.init(scope, element, attrs);

        // last step of initialization. the grid should actually be added
        ang.callAfter(function() {
          // width changes are important after data update
          scope.$watch('width', function() {
            settings.width = scope.width - 5;
            scope.calculateWidths(scope.width);
          });

          // call init of grid

          ang.callAfter(function() {
            if (scope.init() != undefined) {
              scope.init()(scope.gridController, scope);
            }
            // after last stage of initialisation we hide the loading msg and display the real grid.

            element.find('.cfn-grid').show();

            element.find('.loading').hide();
          }, scope);
        });

        if (scope.fixedcols) {
          scope.fixedcols = _.isString(scope.fixedcols)
            ? parseInt(scope.fixedcols)
            : scope.fixedcols;
        }

        scope.headerHeight = cfnGridDefaults.defaults.headerHeight;

        scope.print = function() {
          if (scope.printable == 'true') {
            //                  $(".printableContent",element).append(scope.$$printableHeader);

            app.showLoader();
            scope.calculateWidths(940);
            $('.printableContent', element).append(scope.$$printableContent);

            ang.callAfter(function() {
              ang.callAfter(function() {
                $('.printFrame', element).attr('src', 'print.html');

                var html = ''; // "<h3>Arne test</h3>"; TODO: do we want a header?

                html += $('.printableContent', element).html();

                $('.printFrame', element).load(function() {
                  $('.printFrame', element)
                    .contents()
                    .find('body')
                    .html(html);
                  $('.printFrame', element)[0].contentWindow.focus(); // for ie we have to focus the iframe before
                  $('.printFrame', element)[0].contentWindow.print();
                });

                app.hideLoader();
                scope.calculateWidths(scope.width);
                $('.printableContent', element).html('');
              });
            }, scope);
          }
        };
      },

      template:
        "<div class='cfn-grid' style='display:none;'>" +
        "<div class='cfnTableHeader cfn-table-header' " +
        "style='overflow:hidden; position: relative;'>" +
        '</div>' +
        "<div style='position: relative'>" +
        '<loading-broadcast-hint ' +
        "event-name='grid-loading' " +
        "message='{{loadingDataMessage}}'>" +
        '</loading-broadcast-hint>' +
        '<div ' +
        'class="main-container"' +
        'ng-style=\'{"max-height": noMaxHeight ? none : height-headerHeight}\' ' +
        "style='overflow-x:hidden; margin-bottom:10px;'>" +
        '<div ' +
        "class='pageTop'>" +
        '</div>' +
        "<div class='tableContent clearfix' " +
        "hide-on-loading='grid-loading'>" +
        '</div>' +
        cfnGridTemplates.pagination +
        '</div>' +
        "<div ng-show='!(viewData.length>0)' " +
        "style='position:absolute;top:0px;left:0px;width:100%;height:100%;background:rgba(0,0,0,0.0)'>" +
        "<center class='cfnGridEmptyMsg' hide-on-loading='grid-loading'>" +
        '{{emptyDataString}}' +
        '</center>' +
        '</div>' +
        cfnGridTemplates.loading +
        '</div>' +
        '</div>' +
        '<div class="loading" style="padding:5px;">' +
        "{{'fe.common.pleaseWait'|i18n:'Bitte warten'}} ..." +
        '</div>' +
        '<div ng-transclude>' +
        '</div>' +
        '<div ng-if=\'printable=="true"\'>' +
        "<div class='printableContent'>" +
        '</div>' +
        "<iframe class='printFrame' style='width:1px;height:1px;position:fixed;top:-2px;left:-2px;border:none'>" +
        '</iframe>' +
        '</div>'
    };
  }
]);

angular.module('cfn').directive('cfnColumnNew', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      require: '^cfnGridNew',
      restrict: 'E',
      scope: {
        name: '@',
        value: '@',
        title: '@',
        secondTitle: '@',
        type: '@',
        cellsalign: '@',
        cellclassname: '@',
        align: '@',
        width: '@',
        enum: '@',
        enumOptions: '=',
        // can be used to dynamically show or hide columns. call gridScope.calculateWidths() afterwards
        hidden: '@',
        filterable: '@',
        transform: '@',
        filter: '@',
        renderer: '&',
        onchange: '&',
        onFilterBlurFn: '&', //called when the default filter loose focus.
        displaysize: '@',
        displayprio: '@',
        typeparam: '@',
        minsize: '@',
        maxsize: '@',
        // if to show this column (only evaluated in link phase), e.g. showif="company.vatrate>0"
        showif: '@',
        showifModule: '@', //show only if the mentioned module is active (see app.hasModule)
        aggregateLabel: '@',
        aggregateFn: '&',
        searchMapping: '@',
        showBtnToHideColumn: '@',
        filterSelector: '@',
        customFilterFn: '&',
        filtertypeOverride: '@',
        // If the column should be sortable (default: true)
        sortable: '@',
        // If the column is removable
        removable: '@',
        // must be a string that may have expression like {{item.id}} - will
        // only be used if type is dragger
        geaDragItemTemplate: '=',
        // all enum keys in the value will be replaced by the enum options.
        replaceByEnum: '@',
        unitName: '@'
      },
      terminal: true,
      link: function(scope, element, attrs, cfnGridController) {
        scope.$rootScope = $rootScope;
        if (scope.type === 'innerHtml') {
          scope.innerHtml = element.html();
          element.html('');
        }
        if (scope.type === 'innerHtmlFullHeight') {
          scope.innerHtmlFullHeight = element.html();
          element.html('');
        }

        scope.setAggregateType = function(value) {
          scope.aggregateType = value;
        };
        scope.hasCustomFilterFn = function() {
          return angular.isDefined(attrs.customFilterFn);
        };
        cfnGridController._addColumn(scope);
      }
    };
  }
]);

// These two directives are for synchronizing the vertical scrolling of Nonfixed Coloumns in content-Table and Header,
// as the Header is independent from content-table.
// They have to use the same scope (in our case, the grid's scope), or they won't work.

angular.module('cfn').directive('cfnSynchronizeVertScrollMaster', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs, slaveCtrl) {
      $(element)
        .parent()
        .scroll(function() {
          scope.cfnSynchronizeVertScroll = element.offset().left;
          scope.$apply(scope.cfnSynchronizeVertScroll);
        });
    }
  };
});

angular.module('cfn').directive('cfnSynchronizeVertScrollSlave', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs, slaveCtrl) {
      scope.$watch('cfnSynchronizeVertScroll', function() {
        element.offset({
          top: element.offset().top,
          left: scope.cfnSynchronizeVertScroll
        });
      });
    }
  };
});
